import loadable from '@loadable/component';

/**
 * Code-split wrapper for ForgotPasswordAction — keeps it out of the initial bundle; it renders nothing at
 * first paint. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
const ForgotPasswordAction = loadable(
    /* #__LOADABLE__ */
    () => import('./ForgotPasswordAction'),
    {
        ssr: false,
    }
);

export default ForgotPasswordAction;
